<app-bookme-calendar
  [calendar]="calendar$ | async"
  [timeSlots]="timeSlots$ | async"
  [loadTimeSlotsError]="loadTimeSlotsError"
  (timeSlotSelected)="onTimeSlotSelected($event)"
  (timeRangeChanged)="onTimeRangeChanged($event)"
  (timezoneChanged)="onTimezoneChanged($event)"
  (confirmChanges)="onConfirmChanges()"
  (hostChanged)="onHostChanged($event)"
>
</app-bookme-calendar>
